var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFireFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon fire full"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M12.1736 26.1395C12.6853 29.0419 15.3718 31.3798 16.6511 32.186C16.4379 30.5737 15.2882 27.9535 16.0115 24.9303C16.463 23.043 18.1436 20.8992 19.2098 20.093C19.2098 21.907 19.6471 23.752 19.8494 24.3256C20.489 26.1395 22.408 28.5582 22.408 28.5582C22.9639 27.9535 24.1595 27.3488 25.5225 26.1395C25.5225 26.1395 25.6899 27.3489 24.9665 29.1628C24.2432 30.9767 23.0476 32.7907 22.408 34C23.6873 33.3953 30 30.9767 30 23.7209C30 19.4884 28.7207 18.279 26.8018 15.8605C26.8018 17.0698 27.0584 19.235 26.8018 20.093C26.0784 22.5116 24.9665 23.1163 23.6036 23.7209C24.7991 20.093 24.8828 17.0698 23.6036 14.0465C22.408 11.2211 19.2098 9.2093 17.9305 8C17.9305 9.20927 16.1203 13.5417 14.6485 15.8605C12.7296 18.8837 11.534 22.5116 12.1736 26.1395Z",
    fill: "#F31C4B",
    stroke: "#F31C4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFireFilled);
export default __webpack_public_path__ + "static/media/icon-fire-filled.03cb4ce3d6f496f3749e695845045fab.svg";
export { ForwardRef as ReactComponent };